import {filterByEnvironment} from './environmentFilter';

export function mapInsuranceDetailedInfoToTariffs(widget, limit = 2) {
    if (!widget || !widget.data) {
        return [];
    }

    return filterByEnvironment(widget.data)
        .filter(item => item && item.title_ua && item.desc_ua)
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .slice(0, limit)
        .map(item => {
            return {
                label: item.title_ua,
                value: item.desc_ua
            };
        });
}
